const questions_items =
{
    meta:
    {
        title: 'By status',
        default: 'ALL'
    },
    data:
        [
            {
                id: 'ALL',
                label: 'All'
            },
            {
                id: 'UNANSWERED',
                label: 'Unanswered'
            },
            {
                id: 'FOLLOWED',
                label: 'Followed by you'
            },
            {
                id: 'CLOSED',
                label: 'Answer approved'
            },
            {
                id: 'ANSWERED_NOT_CLOSED',
                label: 'Not approved answers'
            }
        ]
};

const sort_by_items =
{
    meta:
    {
        title: 'Sorted By',
        default: 'by_activity'
    },
    data:
        [
            // {
            //     id: 'by_date',
            //     label: 'Question Date'
            // },
            {
                id: 'by_votes',
                label: 'Highest score'
            },
            {
                id: 'by_activity',
                label: 'Recent activity'
            },
            {
                id: 'by_answer',
                label: 'Most answered'
            }
        ]
};

export { questions_items, sort_by_items }